import { gql } from '@apollo/client/core';

export const ORDER_FISCALIZATION_SETTING_FIELDS = gql`
  fragment OrderFiscalizationSettingFields on OrderFiscalizationSetting {
    id
    organization_id
    location_id
    provider
    enabled
    shifts_enabled
    expected_kkt_inn_masked
    cashier_position
    cashier_last_name
    cashier_display_name
    taxation_system
    vat_rate
    payment_subject
    payment_method
    config_version
    created_at
    updated_at
  }
`;

export const ORDER_FISCAL_WORKSTATION_FIELDS = gql`
  fragment OrderFiscalWorkstationFields on OrderFiscalWorkstation {
    id
    organization_id
    location_id
    workstation_id
    name
    active
    deletable
    kkmserver_version
    kkt_model_masked
    kkt_number_masked
    fn_number_masked
    kkt_status
    terminal_name_masked
    terminal_number_masked
    terminal_status
    kkt_verified_at
    terminal_verified_at
    activated_at
    deactivated_at
    created_at
    updated_at
  }
`;

export const ORDER_FISCALIZATION_READINESS_FIELDS = gql`
  ${ORDER_FISCALIZATION_SETTING_FIELDS}
  ${ORDER_FISCAL_WORKSTATION_FIELDS}

  fragment OrderFiscalizationReadinessFields on OrderFiscalizationReadiness {
    setting_enabled
    effective_enabled
    kkt_status
    terminal_status
    setting {
      ...OrderFiscalizationSettingFields
    }
    active_workstation {
      ...OrderFiscalWorkstationFields
    }
    last_workstation {
      ...OrderFiscalWorkstationFields
    }
  }
`;

export const SHIFT_FIELDS = gql`
  fragment ShiftFields on Shift {
    id
    organization_id
    location_id
    status
    opened_at
    closed_at
    opening_cash
    closing_cash
    closing_cash_expected
    closing_cash_diff
    closing_revenue_mors
    closing_revenue_kkt
    closing_revenue_diff
    kkt_sync
    kkt_fn_serial_masked
    close_comment
    expires_at
    cashier_vatin
    opened_by {
      id
      title
    }
    closed_by {
      id
      title
    }
    kkt_sessions {
      id
      shift_id
      fn_serial_masked
      kkt_shift_number
      opened_at
      closed_at
      close_reason
    }
  }
`;
